export const styles = {
  placesWrapper: {
    position: "relative" as const,
  },

  placesAutocomplete: {
    width: "100%",
  },

  placesInput: {
    width: `100%`,
    height: "35px",
    border: "1px solid",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    padding: "6px 12px",
    fontSize: "1rem",
    outline: `none`,
    textOverflow: `ellipses`,
    color: "rgba(0, 0, 0, 0.87)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: "1.1876em",
    letterSpacing: "0.00938em",

    "&:hover": {
      borderColor: "rgba(0, 0, 0, 0.87)",
    },
  },

  placesRemoveBtn: {
    position: "absolute" as const,
    top: "50%",
    right: "34%",
    transform: "translateY(-50%)",
    borderRadius: "50%",
    padding: "2px",
    minWidth: "24px",

    "&:hover": {
      cursor: "pointer",
    },
  },

  icon: {
    color: "#EE4360",
    marginRight: "16px",
  },

  // textField: {
  //   width: "388px",
  //   borderRadius: "8px",
  //   background: "#FFFFFF",

  //   "& input": {
  //     color: "#00112B",
  //   },

  //   "& fieldset": {
  //     border: "1px solid #E2E2FC",
  //     borderRadius: "8px",

  //     "& span": {
  //       whiteSpace: "nowrap",
  //     },
  //   },
  //   "& label.Mui-focused": {
  //     color: "rgba(0, 0, 0, 0.87)",
  //   },
  //   "& .MuiInput-underline:after": {
  //     borderBottomColor: "#EE4360",
  //   },
  //   "& .MuiOutlinedInput-root": {
  //     "&.Mui-focused fieldset": {
  //       borderColor: "#EE4360",
  //     },
  //   },
  // },

  textFieldV2: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    flexDirection: "row" as const,
    boxSizing: "border-box" as const,
    border: "1px solid #E2E2FC",
    borderRadius: "8px",
    "& fieldset": {
      border: "0px",
    },
    "& .MuiOutlinedInput-root": {
      display: "flex",
      alignItems: "baseline",
      padding: "2px !important",
      paddingRight: "2px !important",
    },
    "& .MuiAutocomplete-endAdornment": {
      display: "none",
    },
    // Dark mode (additive): re-tone the field surface + border to tokens, make the
    // typed input text legible, and re-tone the placeholder. Only applies under the
    // global `.dark` root; light appearance is unchanged.
    "html.dark &": {
      backgroundColor: "hsl(var(--sds-input))",
      borderColor: "hsl(var(--sds-border))",
    },
    "html.dark & .MuiInputBase-input": {
      color: "hsl(var(--sds-foreground))",
    },
    "html.dark & .MuiInputBase-input::placeholder": {
      color: "hsl(var(--sds-muted-foreground))",
      opacity: 1,
    },
  },

  // Dark mode (additive): the suggestions dropdown is portal-rendered, so it is
  // themed via the Autocomplete `classes` prop rather than a descendant selector.
  // Only applies under the global `.dark` root; light appearance is unchanged.
  paper: {
    "html.dark &": {
      backgroundColor: "hsl(var(--sds-popover))",
      color: "hsl(var(--sds-popover-foreground))",
    },
  },
  option: {
    "html.dark &": {
      color: "hsl(var(--sds-popover-foreground))",
    },
    'html.dark &[data-focus="true"]': {
      backgroundColor: "hsl(var(--sds-accent))",
    },
    'html.dark &[aria-selected="true"]': {
      backgroundColor: "hsl(var(--sds-accent))",
    },
    "html.dark & .MuiTypography-colorTextSecondary": {
      color: "hsl(var(--sds-muted-foreground))",
    },
  },
  // The "Start typing…" / "No options" message is portaled inside the paper with
  // an explicit text.secondary color, so it needs its own class-slot dark rule.
  noOptions: {
    "html.dark &": {
      color: "hsl(var(--sds-muted-foreground))",
    },
  },
};

export default styles;
